import { gql, useMutation } from 'urql'
import { BIZ_PLATFORM_SERVICE } from '../../../Constants'
import { PartialBrief } from '../../../Types/Brief'
import { getBizSubmissionParams } from './getSubmissionParams/'

export interface VenueRequest {
  spaceId: number
  hostId: number
  prompt?: string | null
}

export type CreateEventInput = {
  eventTypeID: number
  lat: string
  lon: string
  location: string
  country: string
  radius: string
  attendees: number
  layoutID: string
  isFlexibleWithDates: boolean
  flexibleDatesNote: string
  fromDateTime: string
  toDateTime: string
  spaceFacilityIDs: number[]
  cateringNeeds?: string
  currency: string
  budget: number
  name: string
  additionalNotes?: string
  guestID: number
  guestCompany: string
  automatedInvitationsQualified: boolean
  automatedInvitationsBypassed: boolean
  accountManagerId?: number
  styleIDs: string[]
  venueRequests?: VenueRequest[]
  locationPolygon?: string
}

type CreateEventMutation = {
  createEvent?: {
    ID: number
    UUID: string
  }
}

type CreateEventVariables = {
  input: CreateEventInput
}

const CreateEventDocument = gql`
  mutation createEvent($input: CreateEventInput!) {
    createEvent(input: $input) {
      ID
      UUID
    }
  }
`

const useSubmitBizBriefMutation = () =>
  useMutation<CreateEventMutation, CreateEventVariables>(CreateEventDocument)

export interface Materials {
  options: MaterialsEnum[]
}

export interface Catering {
  covers: number
  menuType?: MenuTypeEnum
  options: CateringOptionsEnum[]
}

export interface Accomodation {
  guests: number
  nights: number
}

export type MaterialsEnum =
  | 'FLIP_CHART'
  | 'ID_BADGES'
  | 'LARGE_SIGNAGE'
  | 'NOTEPADS'
  | 'PENS'
  | 'SMALL_SIGNAGE'

export type MenuTypeEnum = 'OMNIVEROUS' | 'VEGAN' | 'VEGETARIAN'

export type CateringOptionsEnum =
  | 'BREAKFAST'
  | 'LUNCH'
  | 'DINNER'
  | 'TEA_AND_COFFEE'
  | 'ALCOHOLIC_DRINKS'
  | 'SOFT_DRINKS'
  | 'CANAPES'

const useSubmitBizBrief = (): [typeof combinedState, typeof combinedMutation] => {
  const [submittedBriefState, submitBrief] = useSubmitBizBriefMutation()

  const combinedState = {
    ...submittedBriefState,
    error: submittedBriefState.error,
    fetching: submittedBriefState.fetching,
    data: submittedBriefState.data,
  }

  const combinedMutation = async (
    brief: PartialBrief,
    venueRequests?: VenueRequest[],
    prompt?: string
  ): Promise<void> => {
    submitBrief(
      {
        input: {
          ...getBizSubmissionParams(brief),
          ...(venueRequests?.length && {
            venueRequests: venueRequests.map((vr) => ({ ...vr, prompt: prompt ?? null })),
          }),
        },
      },
      { url: BIZ_PLATFORM_SERVICE }
    )
  }

  return [combinedState, combinedMutation]
}

export default useSubmitBizBrief
